import * as React from "react";
import { Grid, Typography, Box, Link } from "@mui/material";
import { ImagesContext } from "../Context";
import AddBillingProviderModal from "./AddBillingProviderModal";
import { formatZip } from "../utils/StringHelper";

interface Props {
  organizationId: any;
  billingProvider: any;
  placeOfServiceList: any[];
  setSelectedOrganization: any;
}

const BillingProvider: React.FC<Props> = ({
  organizationId,
  billingProvider,
  placeOfServiceList,
  setSelectedOrganization,
}) => {
  const images = React.useContext(ImagesContext);

  const [showAddBillingProviderModal, setShowAddBillingProviderModal] =
    React.useState<boolean>(false);

  const openAddBillingProviderModal = () => {
    setShowAddBillingProviderModal(true);
  };

  return (
    <Grid item xs={12} className="info-container">
      <div
        className="overview-container row"
        style={{ justifyContent: "space-between", alignItems: "center" }}
      >
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: 700,
            lineHeight: "18px",
            letterSpacing: "1px",
            color: "#4A4442",
          }}
        >
          Billing Provider
        </Typography>
        {billingProvider ? (
          <Link className="action-icon" onClick={openAddBillingProviderModal}>
            <img
              src={images.pencil_grey}
              width="35"
              alt="Edit Organization"
              className="action-icon-image"
              style={{ width: "20px", maxHeight: "20px" }}
            />
          </Link>
        ) : (
          <Link
            className="action-link row"
            style={{ backgroundColor: "transparent" }}
            onClick={openAddBillingProviderModal}
          >
            <img
              src={images.add_icon}
              alt="Add Charge"
              className="action-icon-image"
              style={{ width: 20, maxHeight: 20 }}
            />
            <span className="app-user-text" style={{ marginLeft: "10px" }}>
              Add Billing Provider
            </span>
          </Link>
        )}
      </div>

      <div className="divider" style={{ margin: "20px 0px 10px 0px" }}></div>

      {billingProvider ? (
        <Box>
          <div className="overview-container row">
            <div className="item-icon-container">
              <img
                src={images.organization_icon}
                alt="Insurance Icon"
                className="action-icon-image"
                style={{ width: 23, maxHeight: 23 }}
              />
            </div>
            <div className="header-text-container">
              <div className="row">
                <h4 className="overview-header">{billingProvider?.name}</h4>
                <h4 className="medical_id_text">
                  #NPI: {billingProvider?.facility_npi}
                </h4>
              </div>
              <p className="overview-detail">
                {[billingProvider?.place_of_service_code]
                  .filter(Boolean)
                  .map((item, index, arr) => (
                    <span key={index + 1}>
                      {item}
                      {index < arr.length - 1 && (
                        <span>&nbsp;&nbsp;•&nbsp;&nbsp;</span>
                      )}
                    </span>
                  ))}
              </p>
            </div>
          </div>

          <div className="divider" style={{ marginLeft: "0px" }}></div>

          <Grid container spacing={2}>
            <Grid item xs={3} className="patient-info-left-container">
              <div className="detail-container">
                <h4 className="detail-header">Address</h4>
                <p className="detail-text">{billingProvider?.address}</p>
                <p className="detail-text">
                  {billingProvider?.city}
                  {billingProvider?.city && ","} {billingProvider?.state}{" "}
                  {formatZip(billingProvider?.zip)}
                </p>
                <p className="detail-text">{billingProvider?.county}</p>
              </div>
            </Grid>
            <Grid item xs={4.5} className="patient-info-left-container">
              <div className="detail-container">
                <h4 className="detail-header">Additional Info</h4>
                {billingProvider?.federal_tax_id && (
                  <p className="detail-text">
                    Federal Tax ID #: {billingProvider?.federal_tax_id}
                  </p>
                )}
                {billingProvider?.id_qualifier && (
                  <p className="detail-text">
                    ID Qualifier: {billingProvider?.id_qualifier}
                  </p>
                )}
                {billingProvider?.provider_number && (
                  <p className="detail-text">
                    Provider Number: {billingProvider?.provider_number}
                  </p>
                )}
                {billingProvider?.notes && (
                  <p className="detail-text">Notes: {billingProvider?.notes}</p>
                )}
              </div>
            </Grid>
            <Grid item xs={4} className="patient-info-left-container">
              <div className="detail-container">
                <h4 className="detail-header">Contact</h4>
                {billingProvider?.phone_number && (
                  <p className="detail-text">{billingProvider?.phone_number}</p>
                )}
              </div>
            </Grid>
          </Grid>
        </Box>
      ) : (
        <Typography
          sx={{
            fontSize: "12px",
            lineHeight: "18px",
            fontWeight: 700,
          }}
        >
          Since this organization uses billing, they may have a separate
          location where billing is processed. Enter that billing address here.
        </Typography>
      )}

      {showAddBillingProviderModal && (
        <AddBillingProviderModal
          billingProvider={billingProvider}
          showAddBillingProviderModal={showAddBillingProviderModal}
          setShowAddBillingProviderModal={setShowAddBillingProviderModal}
          placeOfServiceList={placeOfServiceList}
          organizationId={organizationId}
          setSelectedOrganization={setSelectedOrganization}
        />
      )}
    </Grid>
  );
};

export default BillingProvider;
